/**
 * @generated SignedSource<<de4df325185381703e15b356897d627e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useShareAndRestrictButtonData_content$data = {
  readonly hasInheritedRestrictions: boolean;
  readonly hasRestrictions: boolean;
  readonly hasViewRestrictions: boolean;
  readonly id: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "useShareAndRestrictButtonData_content";
};
export type useShareAndRestrictButtonData_content$key = {
  readonly " $data"?: useShareAndRestrictButtonData_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShareAndRestrictButtonData_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useShareAndRestrictButtonData_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasViewRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    }
  ],
  "type": "Content"
};

(node as any).hash = "de70946ab8382ce693875ea0d834a45c";

export default node;
